var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "download" } }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-between" }, [
        _c("div", { staticClass: "col-md-12 buttons" }, [
          _c("a", { attrs: { href: "https://appsto.re/br/1NETdb.i" } }, [
            _c("img", { attrs: { src: _vm.appStore } })
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://play.google.com/store/apps/details?id=click2giv.app"
              }
            },
            [_c("img", { attrs: { src: _vm.playStore } })]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("h2", [_vm._v("Baixe agora nas lojas de aplicativos")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c262ed06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c262ed06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/DownloadSection.vue
// module id = null
// module chunks = 